import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAuthenticatedUrl, postURL } from "../utils";
import "../assets/styles/Simulation.css";
import { mapJsonToSimResponse } from "../models/Simulation";
import Support from "../components/support";

const Simulation = () => {
  const { sim_id } = useParams();
  const navigate = useNavigate();
  const [simulation, setSimulation] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [redirecting, setRedirecting] = useState(false)

  useEffect(() => {
    const url = `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/${sim_id}`;
    console.log("in useEffect Simulation, url: ", url)

    fetchAuthenticatedUrl(url).then((resp) => {
      console.log(resp);
      if (resp.data) {
        setSimulation(mapJsonToSimResponse(resp.data));
        console.log(resp.data);
      } else {
        // if(resp.)
        setError(resp.error + " " + "check backend service!");
      }
      setIsLoading(false);
    });
  }, [sim_id]);

  const handleNewChat = async () => {
    setRedirecting(true)
    try {
        const url = `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/${sim_id}/start`;
        console.log("creating new chat: ", url)
        postURL(url).then((resp) => {
            console.log(resp);
            if (resp.data) {
              const simResponse = mapJsonToSimResponse(resp.data);
              const chatId = simResponse.chatResponse[0].chatId
              const redirectURL = `${chatId}`
              navigate(redirectURL)
            } else {
              setError(resp.error + " " + "check backend service!");
            }
            setIsLoading(false);
          });      
    } catch (error) {
      console.error('Error creating new chat:', error);
    }
  };

  const StatusTag = ({ status }) => {
    const className = `px-2 py-1 rounded-full font-semibold text-xs ${
      status === 'ACTIVE'
        ? 'bg-green-200 text-green-800'
        : 'bg-red-200 text-red-800'
    }`;
    return <span className={className}>{status}</span>;
  };

  if (isLoading) {
    return <div>Loading... <Support /></div>;
  }

  if (error) {
    return <div>Error: {error} <Support /></div>;
  }

  if (!simulation) {
    return <div>No simulation found <Support /></div>;
  }

  return (
        <div className="bg-gray-100">
        {redirecting &&
            <div
            className="fixed inset-0 flex items-center justify-center z-1000"
            role="status"
          >
            <svg
              aria-hidden="true"
              className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        }
        {!redirecting &&
          <div className="max-w-3xl mx-auto py-8">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Simulation Chats</h2>
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={handleNewChat}
              >
                New Chat
              </button>
            </div>
            {simulation.chatResponse.length === 0 ? (
              <p className="text-gray-500">No chats available.</p>
            ) : (
              <ul>
                {simulation.chatResponse.map((chat, index) => (
                  <li
                    key={index}
                    className="bg-white rounded-lg shadow-md mb-4 p-4"
                  >
                    <h3 className="text-lg font-bold mb-2">
                      Chat ID: {chat.chatId}
                    </h3>
                    <p>
                      <StatusTag status={chat.status} />
                    </p>
                    {/* <p>Status: {chat.status}</p> */}
                    <p>Added On: {chat.addedOn.toLocaleString()}</p>
                    <p><a className="text-white bg-blue-700 font-medium rounded-lg text-sm px-2 py-1 dark:bg-blue-600"
                            href={'/sim/' + sim_id + '/' + chat.chatId} target="_blank">Link</a></p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        }
        </div>
      );
};

export default Simulation